import { Avatar, Badge } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';

/**
 * Owner identity for a My Team event: avatar + name, a "Mine" pill when the
 * current persona owns it, and an unassigned state when no one owns it yet.
 * Scope-agnostic — renders nothing meaningful for My Work events (no owner).
 */
function OwnerChip({ owner }) {
  const { t } = useTranslation('work-queues-app');

  if (!owner) {
    return <span className="text-[11px] italic text-content-faint">{t('team.unassigned')}</span>;
  }

  return (
    <span className="inline-flex items-center gap-1.5">
      <Avatar
        size="sm"
        initials={owner.initials}
        alt={owner.name}
        // The DS `sm` avatar (16px) sets no font-size for initials, so 2 letters
        // inherit the surrounding 11px and overflow the circle. Pin a tiny size +
        // a subtle tint so the initials read cleanly (matches the request block).
        className="border-transparent bg-[#2173FF]/15 text-[8px] font-bold text-content"
      />
      <span className="text-[11px] text-content-muted">{owner.name}</span>
      {owner.isMine && (
        <Badge variant="informative" size="small">
          {t('team.mine')}
        </Badge>
      )}
    </span>
  );
}

export default OwnerChip;
